export const textTypeT1 = [
  {
    id: 1,
    title: "แบบฟอร์มประเมินค่างาน ชำนาญการ",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:w:/g/personal/sophon_m_cmu_ac_th/EcRembiHaOlAt3yT0t801SgB4PT5uTH-CKudr3i_901ggg?e=b7NUZr",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=b8995ec4-6887-40e9-b77c-93d2df34d528",
    type: 1,
  },
  {
    id: 2,
    title: "แบบฟอร์มประเมินค่างาน ชำนาญการพิเศษ",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:w:/g/personal/sophon_m_cmu_ac_th/EQq_XETFqBlOhIWl1lv3GGwBkBp3VAcuj40xwYAYSK-OCw?e=j86KLb",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=445cbf0a-a8c5-4e19-8485-a5d65bf7186c",
    type: 1,
  },
  {
    id: 3,
    title: "แบบฟอร์มประเมินค่างาน เชี่ยวชาญ และเชี่ยวชาญพิเศษ",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EQhfrGfWGUpJgEI_ubpB31QBISOmv7ru5vVVSipNQxay1w?e=WBb5Ix",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=67ac5f08-19d6-494a-8042-3fb9ba41df54",
    type: 1,
  },
];

export const textTypeT2 = [
  {
    id: 1,
    title: "การเขียนประเมินค่างาน โดย คุณปัทมา จักษุรัตน์",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EVzWzd1Pfx5MoNj3VcbFPGwBHUoaBvELdE8uKxCjb1ma7w?e=DPr9Rz",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=ddcdd65c-7f4f-4c1e-a0d8-f755c6c53c6c",
    type: 2,
  },
  {
    id: 2,
    title: "การเขียนประเมินค่างาน กรณีตัวอย่าง โดย กองบุคคล มช.",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EawSLwiSX35MgOUNooxKEJsBua8qgY8gjg3yVHp143Zr0A?e=V2Nh7y",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=082f12ac-5f92-4c7e-80e5-0da28c4a109b",
    type: 2,
  },
  {
    id: 3,
    title: "คู่มือประเมินค่างาน โดย คณะกรรมการข้าราชการพลเรือน (กพ.)",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/Efg7y1NGrEtNlvtWrjoaA44BQBPwLdTuPer5HFYxcL4OPg?e=FmPz14",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=53cb3bf8-ac46-4d4b-96fb-56ae3a1a038e",
    type: 2,
  },
];

export const textTypeT3 = [
  {
    id: 1,
    title: "กฎ ระเบียบ ข้อบังคับ ที่เกี่ยวข้อง",
    linkDownload: "",
    preViewUrl: "https://hr.oop.cmu.ac.th/submenu/progress/subunderpg.php",
    type: 3,
  },
  {
    id: 2,
    title: "ข้อผิดพลาดที่พบบ่อย (Common Mistake)",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EexlMJe53TJIndC-Qh0LnEkBlvmSAlz6_P6CbYeY6_wEOQ?e=FrlmIj",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=973065ec-ddb9-4832-9dd0-be421d0b9c49",
    type: 3,
  },
  {
    id: 3,
    title: "Q&A คำถามเกี่ยวกับการประเมินค่างาน",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/Ef0Zk2WZAgBMpSOhZiXfCFoBOhtEyRa8I_lj6KGvKy_xYg?e=zgeV33",
    preViewUrl:
      "https://o365cmu-my.sharepoint.com/personal/sophon_m_cmu_ac_th/_layouts/15/embed.aspx?UniqueId=659319fd-0299-4c00-a523-a16625df085a",
    type: 3,
  },
];

export const textTypeT4 = [
  {
    id: 1,
    title: "คู่มือการขอกำหนดตำแหน่งทางวิชาการด้านการสอน",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EbPSj_Aa36FAmTWTDYfvTzYBL8SQgoFnehsH83haZkGP5A?e=xkZL8z",
    type: 4,
  },
  {
    id: 2,
    title: "คู่มือสำหรับผู้ขอกำหนดตำแหน่งทำงวิชาการ ด้วยผลงานด้านนวัตกรรม",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/EaHC6onspkFEqrwIlrepZZ8BF_KpwbKVbtcBQs4hmn7B6g?e=Ouj6p4",
    type: 4,
  },
  {
    id: 3,
    title:
      "คู่มือ สำหรับผู้ขอกำหนดตำแหน่งวิชาการ ด้วยผลงานรับใช้ท้องถิ่นและสังคม",
    linkDownload:
      "https://o365cmu-my.sharepoint.com/:b:/g/personal/sophon_m_cmu_ac_th/Ebd3sRkVHw5OotFWd_xLIAQB7XC5YbyQ7npGlGYj2MMLbg?e=3n5qM1",
    type: 4,
  },
];

export const textTypeT5 = [
  {
    id: 1,
    title:
      "1. แบบตรวจสอบเอกสารประกอบการขอตำแหน่งทางวิชาการ มหาวิทยาลัยเชียงใหม่ พ.ศ. 2565",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/document-check-form/",
    type: 5,
  },
  {
    id: 2,
    title:
      "2. หนังสือแจ้งความประสงค์เรื่องการรับรู้ข้อมูลเกี่ยวกับการกำหนดตำแหน่งทางวิชาการ (ใบไม่ประสงค์ทราบ Reader)",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/request-letter-for-the-recognition-of-qualified-persons/",
    type: 5,
  },
  {
    id: 3,
    title: "3. ตารางสรุปผลงานทางวิชาการ",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/performance-inspection-form/",
    type: 5,
  },
  {
    id: 4,
    title:
      "4. แบบประเมินผลการสอน และแบบการประเมินเอกสารประกอบการสอนหรือเอกสารคำสอน ตามเอกสารแนบท้ายตามข้อบังคับฯ พ.ศ. 2565",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/teaching-evaluation-form/",
    type: 5,
  },
  {
    id: 5,
    title: "5. แบบแสดงการมีส่วนร่วมของผลงานทางวิชาการ พ.ศ. 2565",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/5-%e0%b9%81%e0%b8%9a%e0%b8%9a%e0%b9%81%e0%b8%aa%e0%b8%94%e0%b8%87%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%a1%e0%b8%b5%e0%b8%aa%e0%b9%88%e0%b8%a7%e0%b8%99%e0%b8%a3%e0%b9%88%e0%b8%a7%e0%b8%a1%e0%b8%82/",
    type: 5,
  },
  {
    id: 6,
    title: "6. checklist การเสนอขอตำแหน่งทางวิชาการ",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/6-checklist-%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%80%e0%b8%aa%e0%b8%99%e0%b8%ad%e0%b8%82%e0%b8%ad%e0%b8%95%e0%b8%b3%e0%b9%81%e0%b8%ab%e0%b8%99%e0%b9%88%e0%b8%87%e0%b8%97%e0%b8%b2%e0%b8%87%e0%b8%a7/",
    type: 5,
  },
  {
    id: 7,
    title: "7. แบบแสดงการมีส่วนร่วมในผลงานทางวิชาการ (สำหรับข้าราชการ)",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/%e0%b9%81%e0%b8%9a%e0%b8%9a%e0%b9%81%e0%b8%aa%e0%b8%94%e0%b8%87%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%a1%e0%b8%b5%e0%b8%aa%e0%b9%88%e0%b8%a7%e0%b8%99%e0%b8%a3%e0%b9%88%e0%b8%a7%e0%b8%a1%e0%b9%83%e0%b8%99/",
    type: 5,
  },
  {
    id: 8,
    title: "8. ตัวอย่าง แบบฟอร์มประเมินหนังสือโดย peer reviewer หนังสือ/ตำรา",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/%e0%b8%95%e0%b8%b1%e0%b8%a7%e0%b8%ad%e0%b8%a2%e0%b9%88%e0%b8%b2%e0%b8%87-%e0%b9%81%e0%b8%9a%e0%b8%9a%e0%b8%9b%e0%b8%a3%e0%b8%b0%e0%b9%80%e0%b8%a1%e0%b8%b4%e0%b8%99%e0%b8%ab%e0%b8%99%e0%b8%b1%e0%b8%87/",
    type: 5,
  },
  {
    id: 9,
    title: "9.ตัวอย่าง แบบฟอร์มการแก้ไขรายละเอียด peer reviewer หนังสือ/ตำรา",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/%e0%b8%95%e0%b8%b1%e0%b8%a7%e0%b8%ad%e0%b8%a2%e0%b9%88%e0%b8%b2%e0%b8%87-%e0%b9%81%e0%b8%9a%e0%b8%9a%e0%b8%9f%e0%b8%ad%e0%b8%a3%e0%b9%8c%e0%b8%a1%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%81%e0%b8%81%e0%b9%89/",
    type: 5,
  },
  {
    id: 10,
    title:
      "10. แบบสรุปเอกสารจริยธรรมแนบผลงานทางวิชาการประกอบการเสนอขอตำแหน่งทางวิชาการ",
    linkDownload:
      "https://w1.med.cmu.ac.th/personnel/bfd_download/%e0%b9%81%e0%b8%9a%e0%b8%9a%e0%b8%aa%e0%b8%a3%e0%b8%b8%e0%b8%9b%e0%b9%80%e0%b8%ad%e0%b8%81%e0%b8%aa%e0%b8%b2%e0%b8%a3%e0%b8%88%e0%b8%a3%e0%b8%b4%e0%b8%a2%e0%b8%98%e0%b8%a3%e0%b8%a3%e0%b8%a1%e0%b9%81/",
    type: 5,
  },
];
